module.exports = __webpack_public_path__ + "static/img/logo-header@2x.3d601e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-header@2x.png
// module id = k1NC
// module chunks = 0